// User roles and statuses
// Urutan mencerminkan hirarki: SUPER_ADMIN (platform) > ADMIN_BANK_SAMPAH (tenant)
// > PENGELOLA (operasional) > NASABAH (pengguna akhir).
export enum UserRole {
  NASABAH = 'NASABAH',
  PENGELOLA = 'PENGELOLA',
  ADMIN_BANK_SAMPAH = 'ADMIN_BANK_SAMPAH',
  SUPER_ADMIN = 'SUPER_ADMIN'
}

export enum NasabahType {
  PERORANGAN = 'PERORANGAN',
  LEMBAGA = 'LEMBAGA'
}

export enum PengelolaType {
  SEKOLAH_ADIWIYATA = 'SEKOLAH_ADIWIYATA',
  BANK_SAMPAH_UNIT = 'BANK_SAMPAH_UNIT'
}

// Nilai harus sama persis dengan enum Postgres `account_status`
// ('PENDING','ACTIVE','SUSPENDED','INACTIVE') agar penulisan ke DB tidak ditolak.
export enum AccountStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  INACTIVE = 'INACTIVE'
}

export enum TransactionType {
  DEBIT = 'DEBIT',
  KREDIT = 'KREDIT'
}

// Sama dengan enum Postgres `withdrawal_method`.
export enum WithdrawalMethod {
  CASH = 'CASH',
  BANK_TRANSFER = 'BANK_TRANSFER',
  E_WALLET = 'E_WALLET'
}

// Sama dengan enum Postgres `withdrawal_status`.
export enum WithdrawalStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED'
}

export enum EWalletProvider {
  OVO = 'OVO',
  DANA = 'DANA',
  GOPAY = 'GOPAY',
  SHOPEEPAY = 'SHOPEEPAY'
}

export enum EvidenceType {
  STRUK_TIMBANG = 'STRUK_TIMBANG',
  LAINNYA = 'LAINNYA'
}

export enum WasteUnit {
  KG    = 'KG',
  UNIT  = 'UNIT',
  LITER = 'LITER',
}

/**
 * Status verifikasi anggota bank sampah.
 * Menggantikan terminologi KYC yang lazim di fintech — bank sampah bukan
 * lembaga keuangan sehingga istilah "Verifikasi Anggota" lebih tepat.
 *
 * PENDING        — belum diverifikasi (default saat mendaftar)
 * VERIFIED       — sudah diverifikasi oleh pengelola / admin
 * REJECTED       — ditolak verifikasinya
 * NEEDS_REVISION — pengelola meminta nasabah memperbaiki datanya dulu
 */
export enum VerificationStatus {
  PENDING        = 'PENDING',
  VERIFIED       = 'VERIFIED',
  REJECTED       = 'REJECTED',
  NEEDS_REVISION = 'NEEDS_REVISION',
}

export enum ReportType {
  DAILY = 'HARIAN',
  MONTHLY = 'BULANAN', 
  YEARLY = 'TAHUNAN'
}

export enum FileFormat {
  PDF = 'PDF',
  EXCEL = 'EXCEL'
}

export enum AuditAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE'
}

export enum EntityType {
  BRANCH = 'BRANCH',
  PENGELOLA = 'PENGELOLA',
  CATEGORY = 'CATEGORY',
  NASABAH = 'NASABAH',
  PRICE = 'PRICE',
  REPORT = 'REPORT'
}